/**
 * @GENERATED from Figma node 3608:50995
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ConfluenceDark = function (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        d="M2.725 16.67c-.207.338-.44.73-.637 1.041a.636.636 0 0 0 .213.866l4.137 2.546a.637.637 0 0 0 .882-.216c.165-.277.379-.637.611-1.022 1.639-2.705 3.287-2.374 6.26-.955l4.102 1.951a.637.637 0 0 0 .856-.318l1.97-4.455a.637.637 0 0 0-.319-.834 496 496 0 0 1-4.137-1.967C11.088 10.6 6.35 10.774 2.725 16.671"
      />
      <path
        fill={`url(#${_id2})`}
        d="M21.274 6.56c.207-.337.44-.728.637-1.04a.636.636 0 0 0-.213-.866L17.56 2.11a.636.636 0 0 0-.907.21c-.166.276-.379.636-.611 1.021-1.64 2.705-3.288 2.374-6.26.955l-4.09-1.941a.637.637 0 0 0-.855.318l-1.97 4.455a.636.636 0 0 0 .318.834c.866.407 2.587 1.219 4.137 1.967 5.588 2.704 10.327 2.523 13.951-3.367"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={21.007}
          x2={8.491}
          y1={22.437}
          y2={15.245}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.18} stopColor="#0052CC" />
          <stop offset={1} stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id={_id2}
          x1={-5275.98}
          x2={-4842.65}
          y1={15015}
          y2={15512.3}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.18} stopColor="#0052CC" />
          <stop offset={1} stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(ConfluenceDark);
export { ForwardRef as ConfluenceDark };
